import { Link } from "react-router-dom";
import { cities } from "@/data/cities";
import { RevealBlock } from "./Reveal";
import { TID } from "@/lib/testIds";

export default function CitiesList({ compact = false }) {
  const items = compact ? cities.slice(0, 24) : cities;
  return (
    <section
      data-testid={TID.cities.root}
      className="bg-[#F5F3EF] py-24 md:py-40 border-t border-[#D9D6D0]"
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-4 mb-16 md:mb-20">
          <div className="col-span-12 md:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#C17A43] mb-6">
              — Cities & Towns
            </p>
          </div>
          <div className="col-span-12 md:col-span-9">
            <RevealBlock>
              <h2 className="font-serif text-[clamp(2.5rem,6vw,6rem)] leading-[0.9] tracking-tighter text-[#111111]">
                From Yarmouth<br />
                <span className="italic text-[#184C59]">to Cape North.</span>
              </h2>
            </RevealBlock>
            <p className="mt-8 font-sans text-base md:text-lg text-[#111111]/70 max-w-[54ch]">
              Deployed continuously across {cities.length} Nova Scotia communities.
              Each city page carries site-specific intelligence, historical
              context, and localised threat awareness.
            </p>
          </div>
        </div>

        <ul className="border-t border-[#111111]">
          {items.map((c, i) => (
            <li
              key={c.slug}
              className="border-b border-[#D9D6D0] group"
              style={{ opacity: 1 }}
            >
              <Link
                to={`/cities/${c.slug}`}
                data-testid={`${TID.cities.item}-${c.slug}`}
                className="grid grid-cols-12 items-center py-5 md:py-7 gap-4 group-hover:bg-[#111111] group-hover:text-[#F5F3EF] transition-colors duration-500 px-4 -mx-4"
              >
                <div className="col-span-1 font-mono text-[10px] uppercase tracking-[0.28em] opacity-50">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="col-span-6 md:col-span-4">
                  <p className="font-serif text-2xl md:text-4xl leading-none tracking-tight group-hover:italic transition-[font-style] duration-300">
                    {c.name}
                  </p>
                </div>
                <div className="col-span-4 md:col-span-4 font-mono text-[10px] uppercase tracking-[0.28em] opacity-60">
                  {c.region}
                </div>
                <div className="hidden md:block col-span-2 font-mono text-[10px] uppercase tracking-[0.28em] opacity-40">
                  {c.population || "—"}
                </div>
                <div className="col-span-1 text-right text-lg opacity-40 group-hover:opacity-100 group-hover:translate-x-1 transition-transform">
                  →
                </div>
              </Link>
            </li>
          ))}
        </ul>

        {compact && (
          <div className="mt-12 flex justify-end">
            <Link
              to="/cities"
              className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#111111] border-b border-[#111111] pb-1 hover:text-[#C17A43] hover:border-[#C17A43]"
            >
              View all {cities.length} communities →
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
